import {CryptoCurrencyCode, FiatCurrencyCode} from '@raison/types';

export const USD = 'USD' as FiatCurrencyCode;
export const EUR = 'EUR' as FiatCurrencyCode;
export const BTC = 'BTC' as CryptoCurrencyCode;
export const ETH = 'ETH' as CryptoCurrencyCode;
export const USDC = 'USDC' as CryptoCurrencyCode;
export const USDT = 'USDT' as CryptoCurrencyCode;
export const DAI = 'DAI' as CryptoCurrencyCode;
